import React from 'react';
import { Card } from './Card';
import s from './Days.module.scss';


export interface Day {
    idx: number
    day: string;
    day_info: string;
    icon_id: string;
    temp_day: string;
    temp_night: string;
    info: string;
}

const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const Days = ({forecast}: any) => {
    const dayInAWeek = new Date().getDay();
    const forecastDays = WEEK_DAYS.slice(dayInAWeek-1, WEEK_DAYS.length).concat(WEEK_DAYS.slice(0, dayInAWeek));

    return (
            <div className={s.days}>
                    <Card  forecast={forecast} forecastDays={forecastDays}/>
            </div>
    );
};